/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
import { routes } from "@bvi/admin-panel/api-routes";
import { apiContainer, getItemTags, getListTag, invalidateTags, provideTagsList, TagTypes, WithId } from "@bvi/admin-panel/shared/api";
import { getResponseData } from "@bvi/api-interfaces/response";
import { IManageBaseListResponse, IManageBaseResponse } from '@bvi/api-interfaces/response/manage-base-data';

export const defenseApi = apiContainer.injectEndpoints({
  endpoints: (builder) => ({
    getDefenseList: builder.query<IManageBaseListResponse, void>({
      query: () => ({
        url: routes.defense.findAll(),
        method: 'GET',
      }),
      providesTags: (result) =>
        result
          ? [
            ...getItemTags(TagTypes.DEFENSE, getResponseData(result)),
            getListTag(TagTypes.DEFENSE),
          ]
          : [getListTag(TagTypes.DEFENSE)],
    }),

    getByIdDefense: builder.query<IManageBaseResponse, number>({
      query: (id) => ({
        url: routes.defense.findOne(),
        method: 'GET',
        params: { id },
      }),
      providesTags: provideTagsList(TagTypes.DEFENSE)
    }),

    createDefense: builder.mutation<
      IManageBaseResponse,
      { name: string }
    >({
      query: (data) => ({
        url: routes.defense.create(),
        method: 'POST',
        data,
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.DEFENSE)),
    }),

    updateDefense: builder.mutation<
      IManageBaseResponse,
      WithId<{ name: string }>
    >({
      query: ([id, data]) => ({
        url: routes.defense.update(),
        method: 'PUT',
        data: { id, name: data.name },
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.DEFENSE)),
    }),

    deleteDefense: builder.mutation<void, number>({
      query: (id) => ({
        url: routes.defense.remove(),
        method: 'DELETE',
        params: { id },
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.DEFENSE)),
    }),
  }),
});

export const {
  useGetDefenseListQuery,
  useLazyGetDefenseListQuery,
  useGetByIdDefenseQuery,
  useLazyGetByIdDefenseQuery,
  useCreateDefenseMutation,
  useUpdateDefenseMutation,
  useDeleteDefenseMutation
} = defenseApi;


